import script from "./menu-lateral.vue?vue&type=script&setup=true&lang=js"
export * from "./menu-lateral.vue?vue&type=script&setup=true&lang=js"

import "./menu-lateral.vue?vue&type=style&index=0&id=1815f33f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1815f33f"]])

export default __exports__